import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EngineeringIcon from '@mui/icons-material/Engineering';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import Badge from '@mui/material/Badge';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Avatar from '@mui/material/Avatar';
import { useDispatch } from 'react-redux';
import { getfarmer } from '../redux/farmer';
import { Camera, CameraResultType } from '@capacitor/camera';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [gender, setGender] = React.useState("none");
  const [disability, setDisability] = React.useState("none");
  const [ownershipType, setOwnershipType] = React.useState("none");
  const [cultivatingMethod, setCultivatingMethod] = React.useState("none");
  const [water, setWater] = React.useState("none");
  const [personName, setPersonName] = React.useState([]);
  const [person, setPerson] = React.useState("");
  const [base64, setBase64] = React.useState("");
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const names = ["Maize", "Soya Beans", "Onion", "Pepper", "Tomatoes", "Rice"];

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const capture = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Base64,
      });
      const imageBase64 = image.base64String;
      const imageUrl = `data:image/jpeg;base64,${image.base64String}`;
      setPerson(imageUrl);
      setBase64(imageBase64);
    } catch (error) {
      handleSnackbarOpen("Error Capturing Photo", "error");
    }
  };

  const validateForm = () => {
    if (!document.getElementById("farmername").value) return "Farmer Name is required";
    if (gender === "none") return "Gender is required";
    if (disability === "none") return "Disability Status is required";
    if (!document.getElementById("dob").value) return "Date of Birth is required";
    if (!document.getElementById("contact").value) return "Contact is required";
    if (!document.getElementById("idnumber").value) return "ID Number is required";
    if (!document.getElementById("address").value) return "Address is required";
    if (!document.getElementById("community").value) return "Community is required";
    if (!document.getElementById("district").value) return "District is required";
    if (!document.getElementById("region").value) return "Region is required";
    if (!document.getElementById("gpslocation").value) return "Farm GPS Location is required";
    if (!document.getElementById("estimatedfarmsize").value || Number(document.getElementById("estimatedfarmsize").value) <= 0)
      return "Valid Estimated Farm Size is required";
    if (!document.getElementById("actualfarmsize").value || Number(document.getElementById("actualfarmsize").value) <= 0)
      return "Valid Actual Farm Size is required";
    if (ownershipType === "none") return "Ownership Type is required";
    if (!personName.length) return "At least one crop type is required";
    if (cultivatingMethod === "none") return "Cultivating Method is required";
    if (water === "none") return "Water Usage is required";
    if (!document.getElementById("acreage").value) return "Acreage Supported is required";
    if (!document.getElementById("machinery").value) return "Machinery/Equipment is required";
    if (!document.getElementById("others").value) return "Other Descriptions is required";
    if (!base64) return "Farmer photo is required";
    return null;
  };

  const resetForm = () => {
    const fields = [
      "farmername",
      "contact",
      "dob",
      "idnumber",
      "address",
      "community",
      "district",
      "region",
      "gpslocation",
      "estimatedfarmsize",
      "actualfarmsize",
      "acreage",
      "machinery",
      "others",
    ];
    fields.forEach((id) => {
      const element = document.getElementById(id);
      if (element) element.value = "";
    });
    setGender("none");
    setDisability("none");
    setOwnershipType("none");
    setCultivatingMethod("none");
    setWater("none");
    setPersonName([]);
    setPerson("");
    setBase64("");
  };

  const addFarmer = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      handleSnackbarOpen(validationError, "error");
      return;
    }

    setLoading(true);
    const fd = new FormData();
    fd.append("base64Image", base64);
    fd.append("farmername", document.getElementById("farmername").value);
    fd.append("contact", document.getElementById("contact").value);
    fd.append("gender", gender);
    fd.append("disability", disability);
    fd.append("dob", document.getElementById("dob").value);
    fd.append("idnumber", document.getElementById("idnumber").value);
    fd.append("address", document.getElementById("address").value);
    fd.append("community", document.getElementById("community").value);
    fd.append("district", document.getElementById("district").value);
    fd.append("region", document.getElementById("region").value);
    fd.append("gpslocation", document.getElementById("gpslocation").value);
    fd.append("estimatedfarmsize", document.getElementById("estimatedfarmsize").value);
    fd.append("actualfarmsize", document.getElementById("actualfarmsize").value);
    fd.append("ownershiptype", ownershipType);
    fd.append("croptype", personName);
    fd.append("cultivatingmethod", cultivatingMethod);
    fd.append("water", water);
    fd.append("acreage", document.getElementById("acreage").value);
    fd.append("machinery", document.getElementById("machinery").value);
    fd.append("others", document.getElementById("others").value);

    try {
      const response = await axios.post("https://embert.sisrevolution.com/api/farmer/addfarmer/", fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        dispatch(getfarmer({ data: response.data }));
        handleSnackbarOpen("Farmer Added Successfully", "success");
        resetForm();
        handleClose();
      } else {
        handleSnackbarOpen("Failed to Add Farmer", "error");
      }
    } catch (err) {
      handleSnackbarOpen("Error Adding Farmer", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Add Farmer
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Add New Farmer
          <IconButton onClick={handleClose} sx={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
            onSubmit={addFarmer}
          >
            <Box sx={{ width: "100%", textAlign: "center", mb: 2 }}>
              <Badge
                onClick={capture}
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={
                  <CameraAltIcon sx={{ cursor: "pointer", bgcolor: "darkblue", p: 0.75, borderRadius: "50%", color: "white", fontSize: 26 }} />
                }
              >
                <Avatar sx={{ width: 100, height: 100, border: "1px solid #f0f0f0" }} alt="Farmer Photo" src={person} />
              </Badge>
            </Box>
            <TextField
              id="farmername"
              label="Farmer Name"
              type="text"
              required
              autoComplete="current-text"
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Gender</InputLabel>
              <Select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                label="Gender"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Disability Status</InputLabel>
              <Select
                value={disability}
                onChange={(e) => setDisability(e.target.value)}
                label="Disability Status"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
                <MenuItem value="No">No</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="dob"
              label="Date of Birth"
              type="date"
              required
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
            />
            <TextField
              id="contact"
              label="Contact"
              type="tel"
              required
              autoComplete="current-text"
            />
            <TextField
              id="idnumber"
              label="ID Number"
              type="text"
              required
              autoComplete="current-text"
            />
            <TextField
              id="address"
              label="Address"
              type="text"
              required
              autoComplete="current-text"
            />
            <TextField
              id="community"
              label="Community"
              type="text"
              required
              autoComplete="current-text"
            />
            <TextField
              id="district"
              label="District"
              type="text"
              required
              autoComplete="current-text"
            />
            <TextField
              id="region"
              label="Region"
              type="text"
              required
              autoComplete="current-text"
            />
            <Divider sx={{ my: 1 }} />
            <TextField
              id="gpslocation"
              label="Farm GPS Location"
              type="text"
              required
              autoComplete="current-text"
            />
            <TextField
              id="estimatedfarmsize"
              label="Estimated Farm Size"
              type="number"
              required
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">Acres</InputAdornment>,
              }}
            />
            <TextField
              id="actualfarmsize"
              label="Actual Farm Size"
              type="number"
              required
              InputLabelProps={{ shrink: true }}
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">Acres</InputAdornment>,
              }}
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Ownership Type</InputLabel>
              <Select
                value={ownershipType}
                onChange={(e) => setOwnershipType(e.target.value)}
                label="Ownership Type"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Owned">Owned</MenuItem>
                <MenuItem value="Leased">Leased</MenuItem>
                <MenuItem value="Co-operative">Co-operative</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Crops Grown</InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Crops Grown" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
                required
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Cultivating Method</InputLabel>
              <Select
                value={cultivatingMethod}
                onChange={(e) => setCultivatingMethod(e.target.value)}
                label="Cultivating Method"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Shifting Cultivation">Shifting Cultivation</MenuItem>
                <MenuItem value="Subsistence Farming">Subsistence Farming</MenuItem>
                <MenuItem value="Dryland Farming">Dryland Farming</MenuItem>
                <MenuItem value="Monoculture Farming">Monoculture Farming</MenuItem>
                <MenuItem value="Intensive Farming">Intensive Farming</MenuItem>
                <MenuItem value="Irrigated Farming">Irrigated Farming</MenuItem>
                <MenuItem value="Organic Farming">Organic Farming</MenuItem>
                <MenuItem value="Conservation Tillage">Conservation Tillage</MenuItem>
                <MenuItem value="Crop Rotation">Crop Rotation</MenuItem>
                <MenuItem value="Vertical Farming">Vertical Farming</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Water Usage</InputLabel>
              <Select
                value={water}
                onChange={(e) => setWater(e.target.value)}
                label="Water Usage"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Irrigation">Irrigation</MenuItem>
                <MenuItem value="Rain Water">Rain Water</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="acreage"
              label="Acreage Supported"
              type="text"
              required
              autoComplete="current-text"
            />
            <TextField
              id="machinery"
              label="Projects"
              multiline
              rows={4}
              required
              sx={{ m: 1, width: '52ch' }}
            />
            <TextField
              id="others"
              label="Other Descriptions"
              multiline
              rows={4}
              required
              sx={{ m: 1, width: '52ch' }}
            />
            <Box sx={{ textAlign: 'center', width: '100%', mt: 2 }}>
              {loading ? (
                <Button variant="outlined" disabled>Loading...</Button>
              ) : (
                <Button
                  type="submit"
                  variant="outlined"
                  startIcon={<EngineeringIcon />}
                  size="large"
                  sx={{ bgcolor: '#e0eff9', color: '#1976d2' }}
                >
                  Add Farmer
                </Button>
              )}
            </Box>
          </Box>
        </DialogContent>
        <Divider />
      </Dialog>
    </div>
  );
}